module.exports = __webpack_public_path__ + "assets/severe_weather.71568ed7.svg";